<h1 mat-dialog-title>אופיין רשת מים</h1>
<div mat-dialog-content>
  <authority-labs-water-supply-chart
    [staticPressure]="data.staticPressure"
    [residualPressure]="data.residualPressure"
    [totalFlow]="data.flowRate"
    [systemFlow]="data.systemFlow"
    [systemDemand]="data.systemDemand"
  ></authority-labs-water-supply-chart>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>סגור</button>
</div>
